import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from '../../../api/axiosInstance';
export const addCountryFunc = createAsyncThunk(
    "addCountry",
    async ({ data }, thunkAPI) => {
        try {
            const res = await api.post(`dashboard/countries`, data);
            return res.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || { message: error.message });
        }
    }
)
const addCountrySlicer = createSlice({
    name: "addCountry",
    initialState: {
        loading: false,
        data: [],
        error: null,
        apiErrors: {},
        successMessage: "",
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(addCountryFunc.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.apiErrors = {};
        })
        .addCase(addCountryFunc.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.successMessage = action.payload?.message || "";
            })
        .addCase(addCountryFunc.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.apiErrors = action.payload?.errors || {};
            });
    }
});
export default addCountrySlicer.reducer;